
import './style.scss';

export class JCCatalogStoreShop24
{
	constructor(params)
	{
		var i;

		if(!params)
			return;

		this.config = {
			'id'				: params.ID,
			'showEmptyStore'	: params.SHOW_EMPTY_STORE,
			'useMinAmount'		: params.USE_MIN_AMOUNT,
			'minAmount'			: params.MIN_AMOUNT
		};

		this.messages = params.MESSAGES;
		this.classes = params.CLASSES;
		this.sku = params.SKU;
		this.stores = params.STORES;
		this.obStores = {};
		this.emptyStore = null;
		this.isTouchDevice = BX.hasClass(document.documentElement, 'bx-touch');

		BX.ready(BX.delegate(this.init,this));


		BX.addCustomEvent(window, "onCatalogStoreProductChange", BX.proxy(this.offerOnChange, this));
	}

	init()
	{
		var i;

		for (i in this.stores)
		{
			this.obStores[this.stores[i]] = BX(this.config.id+"_"+this.stores[i]);
/*
			if (!this.isTouchDevice)
			{
				let parent = BX.findParent(this.obStores[this.stores[i]], {className: 'shop-item'});

				BX.bind(parent, 'mouseenter', BX.proxy(this.hoverOn, this));
				BX.bind(parent, 'mouseleave', BX.proxy(this.hoverOff, this));
			}
*/
		}

		this.emptyStore = BX(this.config.id + '_empty');
	}

	offerOnChange(id)
	{
		if (!this.sku[id])
			return;

		var curSku = this.sku[id],
			k,
			message,
			parent,
			hasShowedStock = false;

		for (k in this.obStores)
		{
			BX.adjust(this.obStores[k], {props: {className: 'product-item-limit'}});
			message = (!!this.config.useMinAmount) ? this.getStringCount(0, this.messages) : '';
			BX.adjust(this.obStores[k].querySelector('[data-entity="quantity-limit-value"]'), {html: message});


			if (!!curSku[k])
			{
				BX.addClass(this.obStores[k], this.getStringCount(curSku[k], this.classes));
				message = (!!this.config.useMinAmount) ? this.getStringCount(curSku[k], this.messages) : curSku[k];
				BX.adjust(this.obStores[k].querySelector('[data-entity="quantity-limit-value"]'), {html: message});
			}
			else
			{
				BX.addClass(this.obStores[k], this.getStringCount(0, this.classes));
			}

			parent = BX.findParent(this.obStores[k], {className: 'shop-item'});
			if (!!this.config.showEmptyStore || curSku[k] > 0)
			{
				BX.show(parent);
				hasShowedStock = true;
			}
			else
			{
				BX.hide(parent);
			}
		}

		if (!this.config.showEmptyStore)
		{
			if (hasShowedStock)
			{
				BX.hide(this.emptyStore);
			}
			else
			{
				BX.show(this.emptyStore);
			}
		}
	}

	getStringCount(num, arMessage)
	{
		if (num == 0)
			return arMessage['ABSENT'];
		else if (num >= this.config.minAmount)
			return arMessage['LOT_OF_GOOD'];
		else
			return arMessage['NOT_MUCH_GOOD'];
	}
/*
	hoverOn(event)
	{
		const { target } = event;

		clearTimeout(this.hoverTimer);
		target.style.height = getComputedStyle(target).height;
		BX.addClass(target, 'is-hover');

		BX.PreventDefault(event);
	}

	hoverOff(event)
	{
		const { target } = event;

		BX.removeClass(target, 'is-hover');
		this.hoverTimer = setTimeout(
			BX.delegate(function(){
				target.style.height = '';
			}, this),
			300
		);
	}
*/
}